import { circle, featureCollection, point } from '@turf/turf';

export const RADAR_RADIUS_VALUES_KM = [10, 50, 100] as const;

export type RadarCircleCenter = [number, number];

export const isValidRadarCircleCenter = (
  center: unknown
): center is RadarCircleCenter => {
  return (
    Array.isArray(center) &&
    center.length === 2 &&
    Number.isFinite(Number(center[0])) &&
    Number.isFinite(Number(center[1]))
  );
};

export const toRadarCircleCenter = (
  coordinates: unknown
): RadarCircleCenter | null => {
  if (!isValidRadarCircleCenter(coordinates)) {
    return null;
  }

  return [Number(coordinates[0]), Number(coordinates[1])];
};

export const createRadarRadiusFeatureCollection = (
  center: RadarCircleCenter
) => {
  const features = [];

  RADAR_RADIUS_VALUES_KM.forEach(radius => {
    const turfCircle = circle(center, radius, {
      units: 'kilometers',
      steps: 64,
    });

    turfCircle.properties = {
      label: `${radius} km`,
      type: 'outline',
    };

    features.push(turfCircle);

    const edgePoint = point(turfCircle.geometry.coordinates[0][0], {
      label: `${radius} km`,
      type: 'label',
    });

    features.push(edgePoint);
  });

  return featureCollection(features);
};

export const createEmptyRadarRadiusFeatureCollection = () => {
  return featureCollection([]);
};
